'use strict';

(function($) {
    var selectors = {
        timer: '.js-countdown-timer',
        mountNode: '.js-countdown-mount',
        timeStamp: '.js-countdown-timestamp'
    };
    // cache these native functions since we use them multiple times
    var D = Date;
    var M = Math;

    function getTimeRemaining(endtime) {
        if (typeof endtime !== 'object') {
            throw new Error('getTimeRemaining expects a Date object');
        }

        var total = D.parse(endtime) - D.parse(new D());

        return {
            total: total,
            hours: M.floor((total / (1000 * 60 * 60))),
            minutes: M.floor((total / 1000 / 60) % 60),
            seconds: M.floor((total / 1000) % 60)
        };
    }

    function initialiseTimer($element, endtime) {
        var timeInterval;
        var $timer = $element;
        var $hourElem = $timer.find('.js-countdown-hours');
        var $minuteElem = $timer.find('.js-countdown-minutes');
        var $secondElem = $timer.find('.js-countdown-seconds');

        function updateTimer() {
            var t = getTimeRemaining(endtime);

            if (t.total >= 0) {
                $hourElem.html(('0' + t.hours).slice(-2));
                $minuteElem.html(('0' + t.minutes).slice(-2));
                $secondElem.html(('0' + t.seconds).slice(-2));
            }

            if (t.total <= 0) clearInterval(timeInterval);
        }

        updateTimer();
        timeInterval = setInterval(updateTimer, 1000);
    }

    function init() {
        var $timers = $(selectors.timer);

        if (!$timers.length) return;

        $timers.each(function() {
            var $timer = $(this);
            // stores the number of ms that the flash event runs for
            var endtime = $timer.find(selectors.timeStamp).val();

            if (endtime) {
                // `deadline` is calculated from the current date + flash event end time
                var deadline = new D(D.parse(new D()) + parseInt(endtime));
                initialiseTimer($timer, deadline);
            }
        });
    }

    init();
})(window.jQuery);
